import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getMyEmployerSummaryStats } from "../../../api/dossier/getMyEmployerSummaryStats";
import APContactHelpButton from "../../../components/buttons/APContactHelpButton";
import BackButton from "../../../components/buttons/BackButton";
import HomeButton from "../../../components/buttons/HomeButton";
import EmployerPayrollTaxSavingsChart from "../../../components/charts/APCharts/employerPayrollTaxSavings/EmployerPayrollTaxSavingsChart";
import PageContainer from "../../../components/PageContainer";
import EmployerStatsSummaries from "../../../components/stats/employer/EmployerStatsSummaries";
import { filterAccountsByAnalyticsPermission } from "../../../helpers/user";
import { useAuth } from "../../../providers/AuthProvider";
import { User } from "../../../types/User";

const EmployerViewAnalyticsPayrollTaxSavings = ({ me }: { me: User }) => {
  const navigate = useNavigate();
  const [navigationCheckComplete, setNavigationCheck] = useState(false);
  const { getScopedPageUrl } = useAuth();

  const authorisedAccounts = me.accountPermissions
    ? filterAccountsByAnalyticsPermission(me.accountPermissions)
    : [];

  const employerSummaryStats = getMyEmployerSummaryStats();

  useEffect(() => {
    if (authorisedAccounts.length > 0) {
      setNavigationCheck(true);
    } else {
      navigate(getScopedPageUrl("home"), { replace: true });
    }
  });

  if (employerSummaryStats.isError) {
    throw employerSummaryStats.error;
  }

  const isLoading = employerSummaryStats.isLoading;
  const isSuccess = employerSummaryStats.isSuccess;

  return (
    <PageContainer
      title="Lifetime Payroll Tax Savings"
      loading={isLoading || !navigationCheckComplete}
    >
      {isSuccess && navigationCheckComplete && (
        <Stack spacing={2}>
          <Typography variant="labelLarge">
            Estimated lifetime payroll tax savings^ to date.
          </Typography>

          <Box py={2}>
            <EmployerPayrollTaxSavingsChart />
          </Box>

          <Box>
            <EmployerStatsSummaries
              stats={employerSummaryStats.data}
              showPayrollTaxSavingsCalculation={true}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Stack
              spacing={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                pt: 2,
              }}
            >
              <Box sx={{ display: "flex", columnGap: 1, alignItems: "center" }}>
                <BackButton />
                <HomeButton />
              </Box>
              <APContactHelpButton />
            </Stack>
          </Box>
        </Stack>
      )}
    </PageContainer>
  );
};

export default EmployerViewAnalyticsPayrollTaxSavings;
